<template>
  <a-card :bordered="false">
    <div>
      <a-form :form="form" >
        <a-row>
          <a-col :span="12">
            <a-form-item label="系统编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['number']" disabled/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['amount', {initialValue: data.amount}, {rules: [{required: true, message: '必填项，请填写信息'}]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="人民币金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['amount_cny', {initialValue: data.amount_cny}, {rules: [{required: true, message: '必填项，请填写信息'}]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="货币" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                v-decorator="[
                  'currency',
                  {initialValue: data.currency},
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="付款方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                v-decorator="[
                  'payment_method',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_credit_letter_payment_method">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="承兑金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['acceptance_amount', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开出时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-date-picker
                v-decorator="['pay_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="开出时间"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="承兑时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-date-picker
                v-decorator="['acceptance_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="开出时间"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="贴现时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-date-picker
                v-decorator="['discount_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="开出时间"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="到期时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-date-picker
                v-decorator="['due_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="开出时间"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false">
            <a-form-item label="已存档" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-switch v-decorator="['is_archived', { initialValue: data.is_archived, valuePropName: 'checked' }]" checked-children="是" un-checked-children="否"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea :auto-size="{ minRows:1, maxRows:4 }" v-decorator="['remark', {initialValue: data.remark}, {rules: [{required: false, message: '必填项，请填写信息'}]}]" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item v-bind="buttonCol">
          <a-row>
            <a-col span="6" :offset="6">
              <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
            </a-col>
            <a-col span="10">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
            <a-col span="8"></a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </div>
  </a-card>
</template>

<script>
import moment from 'moment'
import { credit_letter_list, credit_letter_update } from '@/api/trade_credit_letter'
import pick from 'lodash.pick'
const fields = ['id', 'number', 'payment_method', 'pay_date', 'acceptance_date', 'discount_date', 'due_date', 'acceptance_amount', 'type', 'amount_cny', 'is_archived', 'remark']
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      currency: this.$Dictionaries.currency,
      data: {}
    }
  },
  mounted () {
    credit_letter_list({ id: this.$route.params.id })
      .then(res => {
        console.log(res.data, '我是数据列表@')
        const list = res.data.entries
        if (list && list.length > 0) {
          this.data = list[0]
          // this.data.currency = '' + this.data.currency
          this.id = this.data.id
          this.loadEditInfo(this.data)
        }
      })
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          credit_letter_update(values, this.id)
            .then((res) => {
              this.handleGoBack()
              console.log(res, '修改成功')
            })
        }
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, fields)
        formData.payment_method = '' + formData.payment_method
        console.log('formData', formData)
        this.id = formData.id
        formData.type = String(formData.type)
        form.setFieldsValue(formData)
      })
    }
  }
}
</script>
